import React from 'react'

import { useUnsafeMemo } from '@factorialco/deprecated-design-system'
import { Bar, BarProps } from 'recharts'

import { BarPosition, BarPositions, OnClickHandler, Serie } from './types'

export const ComboBar: React.FC<{
  series: Serie[]
  tooltipIndex?: number
  onClick?: OnClickHandler
  barPositions?: BarPositions
  setBarPositions: (barPositions: BarPositions) => void
}> = ({ series, onClick, barPositions, tooltipIndex, setBarPositions }) => {
  const positionsRef: BarPositions = {}

  const barPositionKeys = useUnsafeMemo(() => {
    const keys: string[] = []

    series.forEach(({ bars, serieId }) => {
      bars.forEach(({ id }) => {
        keys.push(`${serieId}-${id}`)
      })
    })

    return keys
  }, [series])

  const renderShape = (
    id: string,
    serieId: string,
    props: BarProps,
    positions: { [key: string]: BarPosition }
  ) => {
    const { x, y, fill, index, width, height } = props
    const yPos = Number(height) < 0 ? Number(y) + Number(height) : y
    const finalHeight = Number(height) < 0 ? -Number(height) : Number(height)
    const blur = tooltipIndex !== undefined && Number(index) !== tooltipIndex

    positions[`${index}`] = { x: Number(x), y: Number(y), width: Number(width) }
    return (
      <rect
        x={x}
        y={yPos}
        fill={fill}
        width={width}
        height={finalHeight}
        opacity={blur ? 0.6 : undefined}
        onClick={() => onClick?.({ index, id, serieId })}
      />
    )
  }

  return series.map(({ bars, serieId }) => {
    return bars.map(({ id, color }) => {
      const positions: { [key: string]: BarPosition } = {}

      return (
        <Bar
          dataKey={id}
          fill={color}
          key={`bar-${id}`}
          stackId={serieId}
          shape={(props: BarProps) => renderShape(id, serieId, props, positions)}
          onAnimationEnd={() => {
            positionsRef[`${serieId}-${id}`] = Object.values(positions)
            if (barPositionKeys.every((key) => !!positionsRef[key])) {
              if (JSON.stringify(positionsRef) !== JSON.stringify(barPositions)) {
                setBarPositions(positionsRef)
              }
            }
          }}
        />
      )
    })
  })
}
